export default __webpack_public_path__ + "static/media/del.e9b69549.webp";